import loginStore from "./login";
import dataStore from "./user";

export default {
  modules: {
    loginStore,
    dataStore,
  },
};
